import { Box, Container, Typography } from "@mui/material";
import { motion } from "motion/react";
import Section1 from "./Section1";
import MisionVisionValores from "./MisionVisionValores";
import Servicios from "./Servicios";
import QuienesSomos from "./QuienesSomos";
import Presentes from "./Presentes";
import Contacto from "./Contacto";
import Simuladores from "./Simuladores";


const Home = () => {

    return (
        <>
            <Section1/>
            <QuienesSomos/>
            <MisionVisionValores />
            <Servicios/>
            <Simuladores/>
            <Presentes/>
            <Contacto/>
        </>
    );
};

export default Home;